// Theme is LOCKED to a single Ultratech look — no light/dark switching anymore.
// The toggle has been removed product-wide. `useTheme` always returns 'light' so
// existing consumers keep working; `ThemeToggle` renders nothing.
import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext({ theme: 'light', toggle: () => {} });

export function ThemeProvider({ children }) {
    useEffect(() => {
        // Make sure the dark overrides never apply and clear any stale saved choice.
        document.documentElement.classList.remove('dark');
        try { window.localStorage.removeItem('propulse-theme'); } catch (e) { /* ignore */ }
    }, []);
    return <ThemeContext.Provider value={{ theme: 'light', toggle: () => {} }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);

// Toggle removed product-wide — keeps the import working but renders nothing.
export function ThemeToggle() { return null; }
